module.exports = __webpack_public_path__ + "img/index_zhu.038ec3a6.png";